import React from 'react'
import { HashLink } from 'react-router-hash-link';

import styles from "../../../css/buttonHead.module.css"

const ButtonHead = (props) => {

	const {
		children,
		size,
		link,
		classe
	} = props

	let textSize, padding

	//size
	if(size === 'big') {
		textSize = 'text-sm md:text-lg'
		padding = 'py-4 px-6 md:px-8'
	}else if(size === 'small'){
		textSize = 'text-xs'
		padding = 'py-1 px-3'
	}else{
		textSize = 'text-sm md:text-base'
		padding = 'py-2 md:py-3 px-4 md:px-6'
	}

	/*return (
		<HashLink to={link} className={`${classe} ${textSize} ${padding} inline-block bg-primary hover:bg-primary-ligth text-white`}>
			{ children }
		</HashLink>
	)*/

	return(
		<>
			<HashLink to={link} className={`${ styles.cButton2 } ${ styles.cButtonGooey2 } ${classe} ${textSize} ${padding} inline-block  rounded-full text-white`}>
				{ children }
			  <div className={styles.cButtonBlobs2}>
			  <div></div>
			  <div></div>
			  <div></div>
			  </div>
			</HashLink>
			<svg style={{ display: 'block', height: 0, width: 0 }} version="1.1" xmlns="http://www.w3.org/2000/svg">
			  <defs>
			    <filter id="goo">
			      <feGaussianBlur result="blur" stdDeviation="10" in="SourceGraphic"></feGaussianBlur>
			      <feColorMatrix result="goo" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 18 -7" mode="matrix" in="blur"></feColorMatrix>
			      <feBlend in2="goo" in="SourceGraphic"></feBlend>
			    </filter>
			  </defs>
			</svg>
		</>
	)
}

export default ButtonHead